<template>
  <div class="skill-cards-wrapper" ref="skill-cards-wrapper" :style="getWrapperStyle()">
    <div class="skill-card-wrapper" v-for="skill in skills" :key="skill.id">
      <div class="skill-card">
        <div class="skill-circle">
          <level-circle :name="skill.name" :percentage="skill.percentage" size="150" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LevelCircle from '../LevelCircle'

export default {
  props: {
    skills: {
      type: Array,
      default: () => []
    }
  },
  data: () => {
    return {
      skillCardsWrapperMargin: 0,
      cardWidth: 0,
      skillCardsWrapper: null
    }
  },
  methods: {
    handleResize() {
      const wrapperWidth = this.skillCardsWrapper.clientWidth
      this.skillCardsWrapperMargin = (wrapperWidth % this.cardWidth) / 2
    },
    getWrapperStyle() {
      return `padding: 0 ${this.skillCardsWrapperMargin}px;`
    }
  },
  mounted() {
    this.skillCardsWrapper = this.$refs['skill-cards-wrapper']
    this.cardWidth = this.skillCardsWrapper.children[0].offsetWidth
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    LevelCircle
  }
}
</script>

<style>
.skill-cards-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.skill-card {
  margin: 8px;
}

.skill-circle {
  width: 150px;
  height: 150px;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 2px 1px -1px rgba(0, 0, 0, 0.12);
  background-color: rgb(250, 250, 250);
}

.skills-caption {
  color: rgb(117, 117, 117);
}
</style>
